import SignedInSearch from "../SignedInSearch";
import CategoryCarousel from "../CategoryCarousel";
import ActivitySummary from "../ActivitySummary";
import NewCategories from "../NewCategories";
import GuideCTA from "../GuideCTA";   
import Footer from "../../layout/main/Footer";

export default function DashboardTab() {
  const categories = [
    { name: "Clothing", img: "/assets/images/Sample_Image.png" },
    { name: "Electronics", img: "/assets/images/Sample_Image-1.png" },
    { name: "Home & Decor", img: "/assets/images/Sample_Image2.png" },
    { name: "Stationery", img: "/assets/images/Sample_Image3.png" },
    { name: "Beauty", img: "/assets/images/Sample_Image4.png" },
  ];

  return (
    <div className="w-full">
      <SignedInSearch />

      <div className="max-w-[1400px] mx-auto mt-6">
        <CategoryCarousel items={categories} />
        <ActivitySummary />
        <NewCategories />

        <GuideCTA />

        <Footer />
      </div>
    </div>
  );
}
